import { useContext, useCallback } from 'react';
import _get from 'lodash/get';

import { AjaxContext, AppContext, MerchantContext } from 'commons-ui';

const useService = () => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const { merchantName } = useContext(MerchantContext);

	const sendOtp = useCallback(async (email: string) => {
		const result = await postData({
			endpoint: '/auth/otp/getOtpViaEmail',
			queryParams: {
				appName
			},
			body: {
				email,
				userMerchant: merchantName
			}
		});
		const data = _get(result, ['data'], {});
		return data;
	}, []);

	return { sendOtp };
};

export default useService;
